export default {"src":"/_next/static/image/public/images/flags/flag_678.0d823c3494622d09c77e930006285f4e.svg","height":16,"width":24};